export default "__VITE_ASSET__XoG8G9MN__"